import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { TextField } from "@mui/material";
// import DatePick from "../PromoTab/DatePick";

export default function AddPromoCode ({
  open,
  errMsg,
  msgColor,
  errStatus,
  handleClose,
  handleSubmit,
  promoCodeData,
  handleChange,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const today = moment().format("YYYY-MM-DD");
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Create Promo Code"}</DialogTitle>
        <form onSubmit={handleSubmit} style={{ width: "460px" }}>
          {errStatus && (
            <div
              style={{ color: msgColor, fontSize: "14px", padding: "0 16px", textAlign: "center" }}
            >
              {errMsg}
            </div>
          )}
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <TextField
                    required
                    type='date'
                    inputProps={{ min: today }}
                    fullWidth
                    label='Start Date'
                    name='startDate'
                    variant='outlined'
                    margin='normal'
                    value={promoCodeData?.startDate}
                    onChange={handleChange}
                  />
                  <TextField
                    required
                    type='date'
                    inputProps={{
                      min: moment(promoCodeData?.startDate).add(1, "days").format("YYYY-MM-DD"),
                    }}
                    fullWidth
                    label='End Date'
                    name='endDate'
                    variant='outlined'
                    margin='normal'
                    value={promoCodeData?.endDate}
                    onChange={handleChange}
                  />
                </div>

                {/* <label>Code</label> */}
                <TextField
                  required
                  type='text'
                  inputProps={{ min: 9 }}
                  fullWidth
                  label='Promo Code'
                  name='code'
                  variant='outlined'
                  margin='normal'
                  style={{ marginTop: "5px" }}
                  value={promoCodeData?.code}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <select
                required
                  onChange={handleChange}
                  name='discountType'
                  value={promoCodeData?.discountType}
                  style={{
                    border: "1px solid lightgray",
                    padding: "12px 8px",
                    cursor: "pointer",
                    borderRadius: "6px",
                    width: "100%",
                    color: "gray",
                  }}
                >
                  <option value={""}>Select Discount Type</option>
                  <option value={"percentage"}>Percentage</option>
                  <option value={"fixed"}>Fixed</option>
                </select>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <TextField
                  required
                  type='number'
                  inputProps={{ min: 1 }}
                  fullWidth
                  label={
                    promoCodeData?.discountType == "fixed"
                      ? "Discount Price"
                      : "Discount Percentage"
                  }
                  name='discountValue'
                  variant='outlined'
                  margin='normal'
                  value={promoCodeData?.discountValue}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <TextField
                  required
                  type='number'
                  inputProps={{ min: 1 }}
                  fullWidth
                  label='Maximum Discount Price'
                  name='maxDiscountAmount'
                  variant='outlined'
                  margin='normal'
                  // style={{ width: "50%" }}
                  value={promoCodeData?.maxDiscountAmount}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {/* <label>Minimum Order Price</label> */}
                <TextField
                  required
                  type='number'
                  inputProps={{ min: 1 }}
                  fullWidth
                  label='Minimum Order Price'
                  name='minOrderAmount'
                  variant='outlined'
                  margin='normal'
                  // style={{ width: "50%" }}
                  value={promoCodeData?.minOrderAmount}
                  onChange={handleChange}
                />
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button autoFocus onClick={handleClose}>
            Disagree
            </Button> */}
            <Button type='submit' autoFocus>
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    // marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "120px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};

import moment from "moment";
import { useState } from "react";

function DatePick () {
  // Get today's date in YYYY-MM-DD format using Moment.js
  const today = moment().format("YYYY-MM-DD");

  // Default Start Date: Today
  const [startDate, setStartDate] = useState(today);

  // Default End Date: Tomorrow
  const [endDate, setEndDate] = useState(moment().add(1, "days").format("YYYY-MM-DD"));

  // Handle Start Date Change
  const handleStartDateChange = e => {
    let newStartDate = e.target.value;
    let name = e.target.name;
    if (name == "startDate") {
      setStartDate(newStartDate);

      // Ensure end date is at least 1 day after the start date
      let minEndDate = moment(newStartDate).add(1, "days").format("YYYY-MM-DD");

      // If the current end date is before the minimum allowed, update it
      if (moment(endDate).isBefore(minEndDate)) {
        setEndDate(minEndDate);
      }
    }
    if (name == "endDate") {
      setEndDate(newStartDate);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
      <div style={{ width: "50%" }}>
        <div>
          <label style={{ fontSize: "14px" }}>Start Date*</label>
        </div>
        {/* <input type='date' /> */}
        <div className='date-wrapper'>
          <input
            type='date'
            className='date-input'
            required
            id='date'
            name='startDate'
            value={startDate}
            onChange={handleStartDateChange}
            min={today}
            style={{
              border: "1px solid lightgray",
              padding: "8px",
              borderRadius: "6px",
              width: "100%",
              color: "gray",
            }}
          />
          <label for='date'></label>
        </div>
      </div>

      <div style={{ width: "50%" }}>
        <div>
          <label style={{ fontSize: "14px" }}>End Date*</label>
        </div>
        <input
          type='date'
          name='endDate'
          value={endDate}
          onChange={handleStartDateChange}
          min={moment(startDate).add(1, "days").format("YYYY-MM-DD")}
          style={{
            border: "1px solid lightgray",
            padding: "8px",
            borderRadius: "6px",
            width: "100%",
            color: "gray",
          }}
        />
      </div>
    </div>
  );
}

// export default DatePick;
